import { LocalStorage } from "./LocalStorage";
import { StorageManager } from "./StorageManager";
class PaymentRetryTimestampSerializer {
    serializeForStorage(data) {
        return JSON.stringify(data);
    }
    deserializeFromStorage(raw) {
        try {
            return JSON.parse(raw);
        }
        catch {
            return null;
        }
    }
}
export class PaymentRetryTimestampStorageManager {
    constructor() { }
    static getInstance() {
        if (PaymentRetryTimestampStorageManager.instance === undefined) {
            PaymentRetryTimestampStorageManager.instance = new StorageManager({
                storage: LocalStorage.create(),
                storageKey: "client_paymentRetryStartedAt",
                storageSerializer: new PaymentRetryTimestampSerializer(),
            });
        }
        return PaymentRetryTimestampStorageManager.instance;
    }
    static store(data) {
        PaymentRetryTimestampStorageManager.getInstance().store(data);
    }
    static restore() {
        return PaymentRetryTimestampStorageManager.getInstance().restore();
    }
    static erase() {
        PaymentRetryTimestampStorageManager.getInstance().erase();
    }
}
